import React from 'react';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { validateStartDate, validateEndDate } from '../ThomasCampaigns/ThomasCampaignValidation';
import { OkStatus, FailedStatus } from '../Icons/StatusIcons';
import { printDate } from 'util/dateUtils';
import { canBePublished, canSuperUser } from 'util/p3Validation';

interface P3CampaignPublishProps {
  thomasCampaignStatus: number;
  productFulfillment: any;
  startDate: string;
  endDate: string;
  publishCampaign(): any;
  isConfigurationValid: boolean;
}

const P3CampaignPublish: React.FC<P3CampaignPublishProps> = ({
  productFulfillment,
  publishCampaign,
  thomasCampaignStatus,
  startDate,
  endDate,
  isConfigurationValid
}: P3CampaignPublishProps) => {
  // validate startDate
  const startDateIsValid = !validateStartDate(startDate, {
    endDate
  });

  // validate endDate
  const endDateIsValid = !validateEndDate(endDate, { startDate });
  const isProductFulfilment = productFulfillment ? true : false;

  const getStatusClassName = (isValid: boolean, isRequired: boolean) => {
    if (isValid) {
      return 'child-campaign__status--valid';
    } else {
      if (isRequired) {
        return 'child-campaign__status--invalid';
      } else {
        return 'child-campaign__status--warning';
      }
    }
  };

  const canPublish = (() => {
    if (
      !canBePublished(
        thomasCampaignStatus,
        startDate,
        productFulfillment ? productFulfillment.opportunity_id : ''
      )
    ) {
      console.log('enter in can be  publish canBePublished false');
      return false;
    }

    if (!isConfigurationValid) {
      console.log('enter in can be publish isConfigurationValid false');
      return false;
    }
    if (!startDateIsValid) {
      console.log('enter in can be published start date startDateIsValid false');
      return false;
    }

    if (!endDateIsValid) {
      console.log('enter in can be published endDateIsValid false');
      return false;
    }
    console.log(`can publish product`, productFulfillment);
    if (!productFulfillment) {
      return false;
    }

    // if (!campaignHasConfig) {
    //   return false;
    // }

    return true;
  })();

  const publishStatus = CONSTANTS.CAMPAIGN_STATUS_MAP[thomasCampaignStatus];

  return (
    <section className="card">
      <section className="thomas-campaign__status-container">
        <label>Campaign Status: </label>
        <span className="thomas-campaign__status">{publishStatus}</span>
      </section>
      {/* <section className="thomas-campaign__status-container">
        <label>Configuration: </label>
        <span className="thomas-campaign__status">{configStatus}</span>
      </section> */}
      <section className="child-campaign__status-container">
        {/* <div>
          <label>Configuration Status: </label>
          <span className={`child-campaign__status ${getStatusClassName(campaignHasConfig, true)}`}>
            {campaignHasConfig ? <OkStatus /> : <FailedStatus />}
          </span>
        </div> */}
        <div>
          <label>Configuration Valid: </label>
          <span
            className={`child-campaign__status ${getStatusClassName(isConfigurationValid, true)}`}
          >
            {isConfigurationValid ? <OkStatus /> : <FailedStatus />}
          </span>
        </div>
        <div>
          <label>Opportunity Valid: </label>
          <span
            className={`child-campaign__status ${getStatusClassName(isProductFulfilment, true)}`}
          >
            {isProductFulfilment ? <OkStatus /> : <FailedStatus />}
          </span>
        </div>
        <div>
          <label>Start Date: </label>
          <span className={`child-campaign__status ${getStatusClassName(startDateIsValid, true)}`}>
            {printDate(startDate)}
            {startDateIsValid ? (
              <span>
                <OkStatus />
              </span>
            ) : (
              <FailedStatus />
            )}
          </span>
        </div>
        <div>
          <label>End Date: </label>
          <span className={`child-campaign__status ${getStatusClassName(endDateIsValid, true)}`}>
            {printDate(endDate)}
            {endDateIsValid ? <OkStatus /> : <FailedStatus />}
          </span>
        </div>
      </section>
      {canSuperUser() ? (
        <div>
          <button
            className="btn btn-primary thomas-campaign__publish"
            type="button"
            disabled={!canPublish}
            onClick={publishCampaign}
          >
            Approve
          </button>
        </div>
      ) : null}
    </section>
  );
};

export default P3CampaignPublish;
